import { REACT_APP_API } from '../../config'
import axios from 'axios'

export async function getBranchOffices(carlotSelected) {
    
    let query = ''

    carlotSelected.forEach(carLot => {
        query = query + `car_lot_id[]=${carLot}&`
    })

    query = query.slice(0, -1)

    const response = await axios(`${REACT_APP_API}/branchoffices?${query}`)
    
    const groupBranchOffices = {}
    for(let i in response?.data?.data) {
        const branchOffice = response.data.data[i]
        const name = branchOffice.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        if(!groupBranchOffices[name]) {
            groupBranchOffices[name] = {
                label: "",
                value: "",
                id: [],
                carLotIds: []
            }
        }
        groupBranchOffices[name].label = branchOffice.name
        groupBranchOffices[name].value = branchOffice.name
        groupBranchOffices[name].id = [...groupBranchOffices[name].id, branchOffice.id]
        groupBranchOffices[name].carLotIds = [...groupBranchOffices[name].carLotIds, branchOffice.car_lot_id]
    }
    
    return Object.values(groupBranchOffices)
}
